import { Image as ImageIcon } from "@phosphor-icons/react";

export function MediaEmptyState({ hasSearch }: { hasSearch: boolean }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/60 bg-muted/20 px-6 py-16 text-center">
      <div className="mb-4 flex size-16 items-center justify-center rounded-2xl bg-primary/8">
        <ImageIcon className="size-7 text-primary" />
      </div>
      <h3
        className="text-lg font-semibold text-foreground"
        style={{ fontFamily: "var(--font-heading)" }}
      >
        {hasSearch ? "Nema rezultata pretrage" : "Nema medija"}
      </h3>
      <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">
        {hasSearch
          ? "Pokušajte s drugačijim pojmom za pretragu."
          : 'Uploadujte prvi fajl klikom na dugme "Upload".'}
      </p>
    </div>
  );
}
